// extracted by mini-css-extract-plugin
module.exports = {"headerDescription":"src_headerDescription__3MvVF"};